/** Chuỗi mục "Thông tin tiệm" ở Cấu hình (docs/plans/thong-tin-tiem.md; xem trước + hộp xác nhận: v0.23.0, docs/plans/mau-nganh-hai-app.md). */
export const TT = {
  tab: 'Thông tin tiệm',
  tieuDe: 'Thông tin tiệm',
  goiY: 'Tên tiệm hiện trên ứng dụng đặt lịch, mã QR và hoá đơn.',
  tenTiem: 'Tên tiệm',
  nganh: 'Ngành',
  nganhGoiY:
    'Ngành quyết định màu và biểu tượng của web quầy và ứng dụng đặt lịch. Dịch vụ đã có giữ nguyên.',
  luu: 'Lưu',
  dangLuu: 'Đang lưu…',
  daLuu: 'Đã lưu thông tin tiệm',
  tenNgan: 'Tên tiệm cần ít nhất 2 chữ.',
  /** Khung xem trước dưới hàng chip ngành. */
  xemTruoc: 'Màu và biểu tượng của ngành đã chọn',
  /** Khi tiệm đã có ảnh bìa / logo (v0.23.3): khung cho thấy trang đặt lịch của khách. */
  xemTruocCoAnh: 'Khách thấy thế này',
  nutGia: 'Đặt lịch',
  /** Hộp xác nhận khi bấm Lưu mà ngành đã đổi. */
  hoiDoiTieuDe: 'Đổi ngành của tiệm?',
  /** Đoạn 1 (chữ thường): màu + biểu tượng đổi, khách thấy ở lần mở tới, cái gì giữ nguyên. */
  hoiDoiCau:
    'Màu và biểu tượng của web quầy và ứng dụng đặt lịch sẽ đổi theo ngành mới (khách thấy ở lần mở ứng dụng tới). Dịch vụ, khách và mã QR giữ nguyên.',
  /** Đoạn 2 (chỉ khi khác nhóm ngành): đúng chiều đổi, vd “Kỹ thuật viên” → “Nhân viên”. */
  hoiDoiTenGoi: (cu: string, moi: string) => `Chữ “${cu}” đổi thành “${moi}”.`,
  /** Đoạn 3 (chỉ khi chu kỳ khác). */
  hoiDoiQuayLai: (moi: number, cu: number) =>
    `Nhắc khách quay lại: dịch vụ chưa đặt ngày riêng sẽ nhắc sau ${moi} ngày (trước là ${cu} ngày).`,
  xacNhanDoi: 'Đổi ngành',
  giuNganhCu: 'Giữ ngành cũ',
} as const
